import styled from "styled-components"
import colors from "../styles/colors"
import theme from "styled-theming";
import { ThemeType } from "../styles/theme";

// Set this to non-transparnt to hide content behind the panel if scrolled
export const panelBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.white,
    [ThemeType.dark]: colors.dark2
});

const panelBorderColor = theme("mode", {
    [ThemeType.light]: colors.grey_1,
    [ThemeType.dark]: colors.grey_1
})

export const ContentContainer = styled.div`
    flex: 1;
    z-index: 1;
`

export const Panel = styled.div`
    flex-direction: column;
    display: flex;
    border-bottom: 0;
`

export const PanelBody = styled.div`
    overflow: inherit;
    border: 1px solid ${panelBorderColor};
    border-radius: 25px;
    padding: 25px;
    background-color: ${panelBackgroundColor};
`

export const PanelPadding = styled.div`
    padding: 10px;
`

export const PanelHeading = styled.div`
    display: flex;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
`

export const PanelTitle = styled.div`
    display: flex;
    flex-direction: column;
`
